import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import type {FeatureFlagState} from '../../stores/featureFlagStore';
import type {Ref} from 'vue';
import {storeToRefs} from 'pinia';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';

export async function handleFeatureFlagGuard(
    featureFlag: Ref<FeatureFlagState>,
    from?: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    try {
        // Wait for feature flag to be ready
        const isReady = await featureFlag.value.isReady();

        if (!isReady || featureFlag.value.availableInLicenseTiers) {
            // Redirect to previous page if available, otherwise prevent navigation
            return from ?? false;
        }

        // All checks passed, allow navigation
        return true;
    } catch {
        // Redirect to previous page if available, otherwise prevent navigation
        return from ?? false;
    }
}

export async function requireOauthFeature(
    _to: RouteLocationNormalized,
    from?: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const {oauth} = storeToRefs(useFeatureFlagStore());

    return handleFeatureFlagGuard(oauth, from);
}
